import { SystemCode } from '@/api'
import { ReserveBibliography } from '@/components/modals/ModalReserve/ModalReserve.vue'

export interface ReserveRequest {
  userId: string
  bibliographies: ReserveBibliography[]
  collections: {
    id: number // 資料ID
    collectionNo: string
  }[]
  reserveMethod: string
  reserveSpecifyBranch: SystemCode[]
  specifyCollectionId?: number
  specifyCollectionNo?: string
  reserveRegistrationBranchCode: SystemCode
  reserveRegistrationPlaceCode: SystemCode
  forwardingBranchCode: SystemCode
  reserveRegistrationDate: string
  preferredDate: string
  reserveNoticeAllowed: boolean
  contactMethod: SystemCode
  displayMemo: string
  reserveSetId: number
  reserveGroupId: number
  forwardingPlaceCode: SystemCode
  requestReserve: boolean
}

export function ReserveRequestToJSON(value: ReserveRequest): any {
  return {
    user_id: value.userId,
    bibliographies:
      value.bibliographies.length > 0
        ? value.bibliographies.map(bibliography => {
            return {
              bibliography_real_id:
                bibliography.bibliographyRealId !== 0
                  ? bibliography.bibliographyRealId
                  : undefined,
              reserve_set_rank: bibliography.reserveSetRank || undefined
            }
          })
        : undefined,
    collections:
      value.collections.length !== 0
        ? value.collections.map(collection => {
            return {
              id: collection.id !== 0 ? collection.id : undefined,
              collection_no:
                collection.collectionNo !== ''
                  ? collection.collectionNo
                  : undefined
            }
          })
        : undefined,
    reserve_method: value.reserveMethod,
    reserve_specify_branch_codes:
      value.reserveSpecifyBranch.length > 0
        ? value.reserveSpecifyBranch.map(item => item.code)
        : undefined,
    specify_collection_id:
      value.specifyCollectionId !== 0 ? value.specifyCollectionId : undefined,
    specify_collection_no:
      value.specifyCollectionNo !== '' ? value.specifyCollectionNo : undefined,
    reserve_registration_branch_code: value.reserveRegistrationBranchCode.code,
    reserve_registration_place_code: value.reserveRegistrationPlaceCode.code,
    forwarding_branch_code: value.forwardingBranchCode.code,
    reserve_registration_date: value.reserveRegistrationDate,
    preferred_date: value.preferredDate,
    reserve_notice_allowed: value.reserveNoticeAllowed,
    contact_method: value.contactMethod.code,
    display_memo: value.displayMemo,
    reserve_set_id: value.reserveSetId !== 0 ? value.reserveSetId : undefined,
    reserve_group_id:
      value.reserveGroupId !== 0 ? value.reserveGroupId : undefined,
    forwarding_place_code: value.forwardingPlaceCode.code,
    request_reserve: value.requestReserve
  }
}
